/* eslint-disable @typescript-eslint/no-explicit-any */
import { Avatar, Card, Slider } from "antd";
import dayjs from "dayjs";
import {
  BILLING_MODAL,
  getInitials,
  NET_TERMS,
  PRICING_MODAL,
  SALE_TYPE,
} from "../../../../../../config/utils";

export default function TabDetails(props: any) {
  const { sidebarData } = props;
  return (
    <div className="dashboardTabContent">
      <Card className="right_cards">
        <h6> General details </h6>
        <div
          style={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            marginBottom: "12px",
            gap: "40px",
          }}
        >
          <div style={{ width: "45%" }}>
            <h6 className="miniTitle">Account manager</h6>
            <h6 className="miniDetail">
              <div className="text_with_avatar">
                {sidebarData?.manager_image_url ? (
                  <div className="participant_avatar">
                    <Avatar src={sidebarData?.manager_image_url} size={24} />
                  </div>
                ) : (
                  sidebarData?.manager_name && (
                    <div className="participant_avatar">
                      <Avatar>
                        {getInitials(sidebarData?.manager_name, "")}
                      </Avatar>
                    </div>
                  )
                )}
                {sidebarData?.manager_name ? sidebarData?.manager_name : "-"}
              </div>
            </h6>
          </div>
          <div style={{ width: "45%" }}>
            <h6 className="miniTitle">Type of sale</h6>
            <h6 className="miniDetail">
              {sidebarData?.sale_type
                ? SALE_TYPE[sidebarData?.sale_type as keyof typeof SALE_TYPE]
                : "-"}
            </h6>
          </div>
        </div>

        <div>
          <h6
            className="miniTitle"
            style={{ margin: "0 0 8px 0", paddingTop: 4 }}
          >
            Probability:
          </h6>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Slider
              className="slider_contract"
              value={sidebarData?.probability ?? 0}
              style={{ width: "100%" }}
            />
            {sidebarData?.probability ?? 0}%
          </div>
        </div>
      </Card>

      <Card className="right_cards">
        <h6> Contract terms </h6>
        <div className="widgetCard">
          <div style={{ width: "50%" }}>
            <h6 className="miniTitle"> Start date </h6>
            <h6 className="miniDetail">
              {sidebarData?.start_date
                ? dayjs(sidebarData?.start_date).format("ll")
                : "-"}
            </h6>
          </div>
          <div style={{ width: "50%" }}>
            <h6 className="miniTitle"> End date </h6>
            <h6 className="miniDetail">
              {sidebarData?.end_date
                ? dayjs(sidebarData?.end_date).format("ll")
                : "-"}
            </h6>
          </div>
        </div>

        <div className="widgetCard">
          <div style={{ width: "50%" }}>
            <h6 className="miniTitle"> Renewable </h6>
            <h6 className="miniDetail">
              {sidebarData?.renewable ? "Yes" : "No"}
            </h6>
          </div>
          <div style={{ width: "50%" }}>
            <h6 className="miniTitle"> Pricing model </h6>
            <h6 className="miniDetail">
              {sidebarData?.pricing_model
                ? PRICING_MODAL[
                    sidebarData?.pricing_model as keyof typeof PRICING_MODAL
                  ]
                : "-"}
            </h6>
          </div>
        </div>

        <div className="widgetCard">
          <div style={{ width: "50%" }}>
            <h6 className="miniTitle"> Billing </h6>
            <h6 className="miniDetail">
              {sidebarData?.billing
                ? BILLING_MODAL[
                    sidebarData?.billing as keyof typeof BILLING_MODAL
                  ]
                : "-"}
            </h6>
          </div>
          <div style={{ width: "50%" }}>
            <h6 className="miniTitle"> Net terms </h6>
            <h6 className="miniDetail">
              {sidebarData?.net_terms
                ? NET_TERMS[sidebarData?.net_terms as keyof typeof NET_TERMS]
                : "-"}
            </h6>
          </div>
        </div>
      </Card>

      {/* <Card
        className="profileSidebar"
        style={{ marginTop: "8px", cursor: "pointer" }}
      >
        <div className="documentHeader">
          <h4>Documents</h4>

          <Button className="btn-sm" icon={<PlusIcon />} />
          <Button className="btn-sm" icon={<SearchIcon />} />
        </div>

        <div className="documentListWrapper">
          <Card className="documentList">
            <div className="documentItem">
              <Image
                src="/images/profile/icon-folder.svg"
                preview={false}
                width={16}
              />
              <span> Photo </span>
            </div>
            <div className="documentImage">
              <Image
                src="/images/dummy/document.png"
                preview={false}
                width={"100%"}
              />
            </div>
          </Card>
          <Card className="documentList">
            <div className="documentItem">
              <Image
                src="/images/profile/icon-folder.svg"
                preview={false}
                width={16}
              />
              <span> Photo </span>
            </div>
            <Image src="/images/dummy/document.png" preview={false} />
          </Card>
        </div>
      </Card> */}
    </div>
  );
}
